module.exports = __webpack_public_path__ + "img/red.cda497dd.png";